import {IAuditWithUserInterface} from "../../../../global/audit.interface";
import {IPageableResponse} from "../../../../global/pagging.dto";
import {User} from "../../contract-control/contract-control-interfaces/cc-activity.interface";
 
export enum PlaybookStatusEnum {
    draft = 'draft',
    published = 'published',
}

export interface IPlaybooksByIdTO extends Omit<IAuditWithUserInterface, 'translation'>{
    id:number;
    name: string;
    color: string;
    purpose: string;
    usage: string;
    status: PlaybookStatusEnum;
    workflow_id: number;
    playbook_category_id: number;
    playbook_category: IPlaybookCategoryDTO;
    user:User,
    playbook_guidelines:IGetPlaybookGuidelinesDTO[]
}

export interface IPlaybooksItemDTO extends Omit<IAuditWithUserInterface, 'translation'> {
    id:number;
    name: string;
    color: string;
    status: PlaybookStatusEnum;
    purpose: string;
    usage: string;
    workflow_id: number;
    playbook_category_id: number;
    playbook_guidelines?: IGetPlaybookGuidelinesDTO[]
    playbook_category: IPlaybookCategoryDTO;
    user:User,
    playbook_guidelines_count: number
}

export interface IAddPlaybookDTO  {
     name: string,
     color?: string,
     status:PlaybookStatusEnum,
     playbook_category_id: number,

}

export interface IUpdatePlaybookGuidelineDTO {
     name: string,
     color: string,
     status:PlaybookStatusEnum,
     playbook_category_id: number,
}

export interface IGetPlaybooksListingDto extends  IPageableResponse<IPlaybooksItemDTO>{}

export interface IPlaybookCategoryDTO extends  Omit<IAuditWithUserInterface, 'translation'>{
    id: number,
    name: string
    workspace_id: string
}

export interface IGetPlaybookCategoriesDto extends IPageableResponse<IPlaybookCategoryDTO>{}

export interface IGetPlaybookGuidelinesDTO extends Omit<IAuditWithUserInterface, 'translation'>{
    deleted_at: Date,
    id: number,
    order: number,
    workspace_id:number,
    content: string,
    playbook_id: number,
    playbook_category:IPlaybookCategoryDTO
    playbook_guidelines:IPlaybookGuidelinesDTO[]
}

export interface IPlaybookGuidelinesDTO extends Omit<IAuditWithUserInterface, 'translation'>{
    order:number,
    content:string,
    playbook_id:number,
    workflow_id:number,
}

export interface IAddGuidelineDTO {
    content: string,
}
export interface IUpdateGuidelineDTO {
    id:number,
    order: number
    content: string,
}